import { ActionRow } from "./action-row";

export class ComponentAction {
  public id: string;
  public componentKey: string;
  public serviceId: string;
  public roleId: string;
  public actions: ActionRow[] = [];
}
